import React from "react"
import { Form } from "antd"
import { useNavigate } from "react-router-dom"

// components
import { PrimeButton } from "components-design-system"
import TextInput from "components-design-system/form-fields/TextInput/TextInput"
import ErrorNotification from "../ErrorNotification/ErrorNotification"

// apis
import { postForgotPassword } from "api/hooks/auth/useAuthApis"

// context
import useErrors from "../../../api/utils/useErrors"
import useAppState from "../../../context/hooks/useAppState"

// styles
import "./ForgotPassword.scss"

const ForgotPassword = () => {
  const navigate = useNavigate()
  const { openToastNotification } = useAppState()
  const { errorHandler } = useErrors()
  const [isSubmitLoading, setIsSubmitLoading] = React.useState(false)
  const [error, setError] = React.useState(null)
  const [form] = Form.useForm()

  const handleForgotPassword = async (values) => {
    setIsSubmitLoading(true)

    if (values?.email) {
      try {
        await postForgotPassword({ email: values.email })
        openToastNotification("success", "Success", "Password reset link sent to your email.")
        navigate("/login")
        setError(null)
      } catch (error) {
        setError(error)
      } finally {
        setIsSubmitLoading(false)
      }
    }
  }

  return (
    <div className="prime-forgot-password-container">
      <div className="right-container">
        <Form
          form={form}
          onFinish={handleForgotPassword}
        >
          <div className="content-container">
            <div className="login-header">Enter your email to receive your password reset link</div>
            <div className="input-container">
              <Form.Item
                name="email"
                style={{ marginBottom: "0px" }}
                rules={[{ required: true }, { type: "email" }]}
              >
                <TextInput
                  type="text"
                  placeholder="E-mail"
                  prefix={<i className="fal fa-envelope login-input-icon" />}
                />
              </Form.Item>
              <p className="forgot-password-link">
                <span
                  className="forgot-password-span"
                  onClick={() => navigate("/login")}
                >
                  Back to login
                </span>
              </p>
              <PrimeButton
                htmlType="submit"
                type="primary"
                className="login-btn"
                loading={isSubmitLoading}
              >
                Submit
              </PrimeButton>
              <ErrorNotification error={error} />
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default ForgotPassword
